export { default } from "./col"
